import ErrorLoadPageIcon from 'src/resources/icons/ErrorLoadPageIcon.svg?raw';
import GraphIcon from 'src/resources/icons/GraphIcon.svg?raw';

export const enum ERROR_TYPE {
	FAILED = 'FAILED',
	NO_DATA = 'NO_DATA'
}

// Error configurations
export const defaultErrorsData = {
	FAILED: {
		title: 'Failed to load data',
		description: [
			'Please try refreshing the page.',
			"If that doesn't work, please contact Evinced customer support."
		],
		icon: ErrorLoadPageIcon
	},
	NO_DATA: {
		title: 'No data available',
		description: 'Try adjusting your filters or date range to see data.',
		icon: GraphIcon
	}
};
